export default {
  headerContent: {
    title: 'Generali Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta Nakliyat (Emtea) Sigortası Nedir?',
    description: {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Nakliyat sigortası alıcının, satıcının veya taşımayı yapan firmanın yaptırabileceği emtea’nın nakliye sırasında karşılaşabileceği risklere karsı güvence sağlamaktadır.',
        'Generali sigorta nakliyat sigortası ile sağlamış olduğu güvence malınızı korumaya alarak finansal destek sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Nakliyat Sigortası Türleri Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında düzenlenmekte olan 4 adet poliçe çeşidi bulunmaktadır.',
          subList: [
            'Emtia nakliyatı sigortaları,',
            'Navlun sigortaları,',
            'Kıymet nakliyatı sigortaları,',
            'Tekne sigortası.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Generali Sigorta Nakliyat Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında ana ve ek teminatlar bulunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu teminatlar;',
          subList: ['Tam Ziya', 'Dar Teminat', 'Geniş Teminat']
        },
        {
          paragraph: '<strong>Tam Ziya Teminatı Nedir?</strong>',
          subList: null
        },
        {
          paragraph:
            'Taşıma aracı ve malın tüm değerini kaybedecek derece hasar görmesini halinde karşılık verilen teminattır.',
          subList: null
        },
        {
          paragraph: '<strong>Dar Teminat Nedir?</strong>',
          subList: null
        },
        {
          paragraph:
            'Dar teminat malın ve taşıma aracının uğrayacağı kısmı hasarlar sonucu çıkan masrafları teminat altına almaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Geniş Teminat Nedir?</strong>',
          subList: null
        },
        {
          paragraph:
            'Geniş teminat ile taşınan malda taşıma esnasında oluşacak kaza veya olay neticesindeki maddi kayıplara karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Nakliyat Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası ile yükün taşıma esnasında kötü hava şartları, fırtına, karaya oturma, çarpma ve çarpışma sonucu meydana gelen zararları güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Nakliyat Poliçesi Düzenlenirken Talep Edilen Bilgiler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Firma ise vergi kimlik numarası, şahıs ise TC numarası.',
            'Sevk başlangıç ve bitiş noktası.',
            'Sevk Başlangıç ve bitiş tarihleri.',
            'Sevki gerçekleştirecek araç bilgileri.',
            'Emtea Türü.',
            'Emtea Bedeli.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Nakliyat Poliçesi Hasar Anında Talep Edilen Belge/Bilgiler Nelerdir?',
      content: [
        {
          paragraph:
            'Hasar anında istenen bilgi ve belgeler hasar boyutuna göre değişmektedir.',
          subList: [
            'Genel olarak aşağıdaki bilgi ve belgeler istenmektedir.',
            'Poliçe numarası',
            'Hasar tarihi',
            'Tahmini hasar miktarı',
            'Sigortalının veya irtibat kurulacak kişinin iletişim bilgisi'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta’dan Neden Nakliyat Sigortası Almalıyım?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası taşınan emteanın nakliye sırasında karşılaşabileceği risklere karşı koruma sağlamaktadır. Generali Sigorta nakliyat sigortası almanız sizi bu risklerin meydana gelmesi sonucunda oluşacak büyük boyutlardaki finansal zararları önlemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Nakliyat Sigortası Yaptırmak Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası yaptırmak için her hangi bir zorunluluk bulunmamaktadır. Kişiler kendi ihtiyaçlarına göre tercih edebilirler.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Nakliyat Sigortası Kim Tarafından Yaptırılır?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası, taşıyıcı, emtea sahibi veya alacaklı kişi tarafından yaptırılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Nakliyat Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası fiyatları, yükün cinsi, adeti ve taşıma şekli gibi etkenlere göre değişmektedir. Bu nedenle net bir nakliyat sigortası fiyatı bulunmamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Nakliyat sigortası fiyatlarını öğrenmek için sigorta uzmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Nakliyat Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Alokasko uzmanlarından fiyat teklifi alabilmek için sorunsuz ulaşım sağlayabileceğiniz çağrı merkezi, online teklif ekranı ve başvuru formu bulunmaktadır. Bu 3 yöntemden birini seçerek nakliyat sigortası hakkında bilgi alabilir, teklifleri değerlendirebilir ve poliçe tanzim edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Generali Sigorta Nakliyat sigortası hakkında kafanıza takılan sorular için sigorta uzmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Nakliyat sigortası fiyat teklifi için başvuru formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    }
  ]
}
